// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__31A35","agree":"App_agree__3M-_s"};